export function splitFullName (fullName: string): {
  firstName: string;
  lastName: string;
} {
  const trimmed = fullName.trim()
  const nameParts = trimmed.split(' ')
  const firstName = nameParts[0] || ''
  const lastName = nameParts.slice(1).join(' ') || '21'
  return { firstName, lastName }
}
